/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {

    declare var landingPageConfigurationSelf: LandingPageConfigurationModel;

    export class LandingPageConfigurationDto {
        Id: string;
        Name: string;
        Order: number;
        ContentPageId: string;
        ProcessTypeId: string;
        SecurityMatrixId: string;
        SecurityMatrixUniqueIdentifier: string;
        IsSingleInstanceProcess: boolean;
    }

    export class LandingPageConfigurationModel {
        public landingPageConfiguration: Wars.Domain.Model.Dtos.LandingPageConfigurationDto;
        public landingPageConfigurationDtos: Wars.Domain.Model.Dtos.LandingPageConfigurationDto[];
        public contentPageDtos: Wars.Domain.Model.Dtos.ContentPageDto[];
        public activeProcessTypes: Wars.Domain.Model.ProcessType[];
        public processSecurityMatrices: any;

        constructor(
            private landingPageConfigurationService: warsApp.services.LandingPageConfigurationService,
            private contentPageService: warsApp.services.ContentPageService,
            private securityMatrixService: warsApp.services.SecurityMatrixService,
            private processTypeService: services.ProcessTypeService,
            private modalService: any,
            private growlService: angular.growl.IGrowlService) {
            landingPageConfigurationSelf = this;
            landingPageConfigurationSelf.processSecurityMatrices = [];

            landingPageConfigurationSelf.landingPageConfigurationService.getLandingPageConfigurations()
                .then(landingPageConfigurations => {
                    landingPageConfigurationSelf.landingPageConfigurationDtos = landingPageConfigurations;
                });

            landingPageConfigurationSelf.contentPageService.getContentPagesForConfiguration()
                .then(pages => {
                    landingPageConfigurationSelf.contentPageDtos = pages;
                });

            landingPageConfigurationSelf.processTypeService.getActiveProcessTypes().then(result => {
                landingPageConfigurationSelf.activeProcessTypes = result;
            });
        }

        public addLandingPageConfiguration() {
            var securityMatrix = landingPageConfigurationSelf.securityMatrixService.createSecurityRow(true);
            var landingPageConfigurationDto = new LandingPageConfigurationDto();
            landingPageConfigurationDto.Name = "New Landing Page";
            landingPageConfigurationDto.Order = landingPageConfigurationSelf.landingPageConfigurationDtos.length + 1;
            landingPageConfigurationDto.SecurityMatrixId = securityMatrix.id;

            landingPageConfigurationSelf.securityMatrixService.saveAllChanges(() => {
                landingPageConfigurationSelf.landingPageConfigurationService.addLandingPageConfiguration(landingPageConfigurationDto)
                    .then((landingPageConfiguration) => {
                        landingPageConfigurationSelf.landingPageConfigurationDtos.push(landingPageConfiguration);
                    });
            });
        }

        public updateLandingPageConfiguration(landingPageConfiguration: Wars.Domain.Model.Dtos.LandingPageConfigurationDto) {
            landingPageConfigurationSelf.landingPageConfigurationService.updateLandingPageConfiguration(landingPageConfiguration);
        }

        public updateLandingPageConfigurationProcess(landingPageConfiguration: Wars.Domain.Model.Dtos.LandingPageConfigurationDto) {
            landingPageConfiguration.securityMatrixUniqueIdentifier = null;
            if (landingPageConfiguration.processTypeId) {
                landingPageConfiguration.isSingleInstanceProcess = Enumerable.from(landingPageConfigurationSelf.activeProcessTypes).first(i => i.id === landingPageConfiguration.processTypeId).isSingleInstanceProcess;
            } else {
                landingPageConfiguration.isSingleInstanceProcess = false;
            }
            landingPageConfigurationSelf.landingPageConfigurationService.updateLandingPageConfiguration(landingPageConfiguration);
        }

        public sortLinks($item: Wars.Domain.Model.Dtos.LandingPageConfigurationDto, $partFrom: Wars.Domain.Model.Dtos.LandingPageConfigurationDto[], $partTo, $indexFrom, $indexTo, $modal) {
            var arrayCopy = Enumerable.from($partFrom).orderBy(z => z.order).toArray();

            var spliced = arrayCopy.splice($indexFrom, 1);
            arrayCopy.splice($indexTo, 0, spliced[0]);

            $item.order = $indexTo;

            for (var i = 0; i < $partFrom.length; i++) {
                var numberId = $partFrom[i].id;
                $partFrom[i].order = Enumerable.from(arrayCopy).indexOf(i => i.id == numberId);
            }

            landingPageConfigurationSelf.landingPageConfigurationService.updateLandingPageConfigurations(landingPageConfigurationSelf.landingPageConfigurationDtos);
        }

        public openProcessSecurityMatrixModal(landingPageConfiguration: Wars.Domain.Model.Dtos.LandingPageConfigurationDto) {
            landingPageConfigurationSelf.processTypeService.getActiveProcessTypeAndSecurity(landingPageConfiguration.processTypeId)
                .then(processType => {
                    var activeProcessConfiguration = Enumerable.from(processType.processConfigurations).firstOrDefault(i => i.configurationStatus === Wars.Domain.Model.Codes.Enums.ConfigurationStatus.Active);
                    if (activeProcessConfiguration) {
                        if (activeProcessConfiguration.mySecurityMatrices.length > 0) {
                            var currentMatrix = Enumerable.from(activeProcessConfiguration.mySecurityMatrices).firstOrDefault(ii => ii.uniqueIdentifier === landingPageConfiguration.securityMatrixUniqueIdentifier);
                            landingPageConfigurationSelf.modalService.showModal({
                                templateUrl: "./app/views/modals/landingPageConfigurationSingleInstanceModal.html",
                                controller: "landingPageConfigurationSingleInstanceModalController",
                                inputs: {
                                    securityMatrices: activeProcessConfiguration.mySecurityMatrices,
                                    uniqueIdentifier: currentMatrix ? currentMatrix.uniqueIdentifier : null
                                }
                            }).then(modal => {
                                // The modal object has the element built, if this is a bootstrap modal
                                // you can call 'modal' to show it, if it's a custom modal just show or hide
                                // it as you need to.                
                                modal.element.modal();
                                modal.close.then(result => {
                                    if (result) {
                                        landingPageConfiguration.securityMatrixUniqueIdentifier = result;
                                        landingPageConfigurationSelf.landingPageConfigurationService.updateLandingPageConfiguration(landingPageConfiguration);
                                    }
                                });
                            });
                        } else {
                            landingPageConfigurationSelf.growlService.error("No Security Matrices available in this Process Configuration.");
                        }
                    } else {
                        landingPageConfigurationSelf.growlService.error("No Active Process Configuration for this Process Type.");
                    }
                });
        }

        public openSecurityMatrixModal(landingPageConfiguration: Wars.Domain.Model.Dtos.LandingPageConfigurationDto) {
            landingPageConfigurationSelf.securityMatrixService.fetchById(landingPageConfiguration.securityMatrixId, "SecurityMatrix")
                .then((securityMatrix) => {
                    landingPageConfigurationSelf.securityMatrixService.openSecurityMatrixModal(securityMatrix, undefined);
                });
        }

        public removeLandingPageConfiguration(landingPageConfiguration: Wars.Domain.Model.Dtos.LandingPageConfigurationDto) {
            landingPageConfigurationSelf.landingPageConfigurationService.deleteLandingPageConfigurations(landingPageConfiguration)
                .then(() => {
                    landingPageConfigurationSelf.landingPageConfigurationDtos.remove(landingPageConfiguration);
                });
        }
    }
}